<template>
  <div style="height: 100%;">
    <Split v-model="split_setting1" :mode="layout" @on-move-end="show_up_down_button = true">
      <div :slot="layout === 'horizontal' ? 'left' : 'top'" style="height: 100%">
        <BaseContainer :style="MyStyle(1)">
          <slot name="table1" />
        </BaseContainer>
      </div>
      <div :slot="layout === 'horizontal' ? 'right' : 'bottom'" style="height: 100%">
        <BaseContainer :style="MyStyle(2)">
          <slot name="table2" />
        </BaseContainer>
      </div>
      <div slot="trigger" class="customerCss text-center">
        <div class="ivu-split-trigger ivu-split-trigger-vertical">
          <div class="ivu-split-trigger-bar-con vertical" v-show="!show_up_down_button">
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
            <i class="ivu-split-trigger-bar"></i>
          </div>
          <b-button v-show="show_up_down_button" variant="primary" class="mr-1" style="
            margin-top: calc(50vh - 158px);
            margin-left:-5px;
            padding: 0;
            /* font-size:6px; */
            /* background-color: #c0c4cc; */
            border-color: #c0c4cc;
          " size="sm" @click="uptable">
            <i class="icon iconfont icon-left2"></i>
          </b-button>
          <b-button v-show="show_up_down_button" variant="primary" style="
            margin-top: 1rem;
            margin-left:-5px;
            padding: 0;
            /* font-size:6px; */
            /* padding-left:2px;
            padding-right:2px; */
            /* z-index: 999; */
            /* background-color: #c0c4cc; */
            border-color: #c0c4cc;
          " size="sm" @click="splittable">=</b-button>
          <b-button v-show="show_up_down_button" class="ml-1" variant="primary" style="
            margin-top: 1rem;
            margin-left:-5px !important;
            padding: 0;
            /* font-size:6px; */
            /* background-color: #c0c4cc; */
            border-color: #c0c4cc;
          " size="sm" @click="downtable">
            <i class="icon iconfont icon-right2"></i>
          </b-button>
        </div>
      </div>
    </Split>
  </div>
</template>


<script>
import Vue from "vue";
import BaseContainer from "../BaseContainer";
import { Split } from "view-design";
import "view-design/dist/styles/iview.css";

export default {
  components: {
    BaseContainer,
    Split,
  },
  props: {
    layout: { type: String, default: () => "horizontal" },
    split_setting: { type: Number, default: () => 0.5 },
  },
  data() {
    return {
      split_setting1: this.split_setting,
      show_up_down_button: true,
    };
  },
  computed: {
    MyHeight() {
      return this.$root.GetBasePanelHeight;
    },
  },
  methods: {
    MyStyle(position) {
      if (this.layout === "horizontal") {
        if (position === 1) {
          return "padding: 0 2px 0 0; height: 100%";
        } else {
          return "padding: 0 0 0 2px; height: 100%";
        }
      } else {
        if (position === 1) {
          return "padding: 0 0 2px 0; height: 100%";
        } else {
          return "padding: 2px 0 0 0; height: 100%";
        }
      }
    },
    uptable() {
      this.split_setting1 = 0.25;
    },
    downtable() {
      this.split_setting1 = 0.75;
    },
    splittable() {
      // this.show_up_down_button = false;
      this.split_setting1 = this.split_setting;
    },
  },
};
</script>

<style>
.customerCss {
  cursor: row-resize;
  height: 6px;
  border: 1px solid #dcdee2;
  height: 100%;
  background: #f8f8f9;
  border-left: none;
  border-right: none;
  background: brown;
}
.sf-dropdown {
  font-size: 0.8rem;
}
.sf-dropdown .dropdown-item {
  padding: 0;
}
.split3-right {
}

.split3-right .ivu-split-trigger-con {
  position: absolute;
  transform: translate(-49.5%, -50%);
  z-index: 10;
}
</style>
